import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React from "react";
import MobileSideNavBar from "./side-nav-bar";
import CRMRoutes from "@/routes/crm-routes";
import { usePathname } from "next/navigation";
import Logo from "@/components/logo";
import NavLink from "./nav-link";
import NavMenu from "./nav-menu";
import { GetFontAwesomeIcon } from "@/components/font-awesome-icon";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { useSelector } from "react-redux";
import { selectRoles } from "@/store/slices/roles/rolesSlice";

const initialAnchoEl = { lead: null };
const LeftNavSection = () => {
  const [anchorEl, setAnchorEl] = React.useState(initialAnchoEl);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const pathname = usePathname();
  const { roles } = useSelector(selectRoles);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  // const isProfileMenuOpen = Boolean(anchorEl["profile"]);

  const handleMenuOpen = (event, type) => {
    let name = event?.currentTarget?.name || type;
    let tempRef = { ...anchorEl };
    tempRef[name] = event.currentTarget;
    setAnchorEl(tempRef);
  };

  const handleMenuClose = (e) => {
    e.stopPropagation();
    setAnchorEl(initialAnchoEl);
    // handleMobileMenuClose();
  };

  return (
    <>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={handleDrawerToggle}
        sx={{ mr: 2, display: { sm: "none" } }}
      >
        <MenuIcon />
      </IconButton>
      <Typography
        variant="strong"
        component="strong"
        className="align-items-center"
        sx={{
          display: { sm: "flex" },
          width: { xs: "100%", sm: "inherit" },
          textAlign: "center",
        }}
      >
        {/* Logo/Name */}
        <Logo />
        {/* <Typography variant="h4" color="primary" sx={{ marginRight: 2 }}>
          ApexBusiness
        </Typography> */}
      </Typography>
      <Box
        sx={{ flexGrow: 1, display: { xs: "none", sm: "flex" }, gap: "6px" }}
      >
        {CRMRoutes.map((item) =>
          roles && roles[item?.name]?.view ? (
            !item?.childRoutes ? (
              <NavLink
                key={item?.name}
                item={item}
                sx={{
                  fontWeight: "500",
                  fontSize: "1.1rem",
                  color: "var(--palette-header_text)",
                }}
              >
                {item?.title}
              </NavLink>
            ) : (
              <NavLink
                key={item?.name}
                item={item}
                size="large"
                aria-label={item?.name}
                color="inherit"
                name={item?.name}
                hasChild={true}
                aria-controls={item?.name}
                aria-haspopup={item?.haspopup}
                onClick={item?.haspopup ? handleMenuOpen : null}
                sx={{
                  fontWeight: "500",
                  fontSize: "1.1rem",
                  color: "var(--palette-header_text) ",
                }}
              >
                {item?.title}
                <GetFontAwesomeIcon
                  icon={faChevronDown}
                  iconStyles={{ marginLeft: "5px" }}
                />
                <NavMenu
                  isMenuOpen={Boolean(anchorEl[item?.name])}
                  menuOptions={item?.childRoutes}
                  anchorEl={anchorEl[item.name]}
                  handleMenuClose={handleMenuClose}
                  name={item?.name}
                  pathname={pathname}
                  roles={roles}
                />
              </NavLink>
            )
          ) : null
        )}
      </Box>

      <MobileSideNavBar
        isOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        navItems={CRMRoutes}
      />
    </>
  );
};

export default LeftNavSection;
